/* External */
import isEqualL from "lodash/isEqual";
import jwt_decode from "jwt-decode";

/* Ott-common */
import { createBackendService, createRenewCredentialsFull } from "@dtvgo/backend-service";

/* Actions */
import { logout, setUser } from "../state/user/actions";

/* Services */
import forgeRockService from "./forgeRock";

/* Others */
import store from "../state/configureStore";
import {
  FR_ACCESS_TOKEN,
  FR_ID_TOKEN,
  getEntitlementsList,
  getDeviceId,
  getRenewEntitlements,
  getFrToken,
  getFrIdToken,
  getSessionToken,
  RENEW_ENTITLEMENTS,
  SESSION_TOKEN
} from "../state/localStorage";
import { FORGE_ROCK_LOGIN_SCOPE, SERVICES_CLIENT_ID, getUserTypeByBusinessUnit, USER_TYPES } from "../utils";

let storedCredentials;

const getCredentials = () => {
  const renewEntitlements = getRenewEntitlements();

  const credentials = {
    accessTokenData: {
      accessToken: getFrToken(),
      expireDate: renewEntitlements?.expireDate,
      idToken: getFrIdToken(),
      refreshToken: renewEntitlements?.refresh_token
    },
    sessionTokenData: {
      sessionToken: getSessionToken()
    }
  };

  if (!isEqualL(storedCredentials, credentials)) storedCredentials = credentials;

  return storedCredentials;
};

const setCredentials = ({
  accessTokenData: { accessToken, expireDate, idToken, refreshToken },
  sessionTokenData: { sessionToken }
}) => {
  const { user: { account: { msoProvider = "" } = {} } = {} } = store.getState();

  const renewEntitlements = {
    expireDate,
    refresh_token: refreshToken
  };

  const { businessUnit, msoProvider: idTokenMsoProvider } = jwt_decode(idToken);
  const convivaAccountType = getUserTypeByBusinessUnit(businessUnit, idTokenMsoProvider);

  // Update Local Storage items
  localStorage.setItem(SESSION_TOKEN, sessionToken);
  localStorage.setItem(RENEW_ENTITLEMENTS, JSON.stringify(renewEntitlements));
  localStorage.setItem(FR_ACCESS_TOKEN, accessToken);
  localStorage.setItem(FR_ID_TOKEN, idToken);

  // Update Redux store
  store.dispatch(
    setUser({
      frIdToken: idToken,
      frToken: accessToken,
      renewEntitlements,
      sessionToken,
      account: {
        isTVE: convivaAccountType === USER_TYPES.TVE,
        msoProvider: msoProvider || idTokenMsoProvider,
        userType: convivaAccountType
      }
    })
  );
};

export default createBackendService({
  clientId: SERVICES_CLIENT_ID,
  clientType: SERVICES_CLIENT_ID,
  getAppVersion: () => process.env.REACT_APP_PRIVATE_WEB_MOBILE_VERSION,
  getCredentials,
  getEntitlementsList,
  renewCredentialsCreator: createRenewCredentialsFull({
    deviceId: getDeviceId(),
    forgeRockService,
    forgeRockScope: FORGE_ROCK_LOGIN_SCOPE,
    getUserProfile: () => store.getState()?.user?.account,
    onFailed: () => store.dispatch(logout())
  }),
  setCredentials,
  versionApiByService: {
    content: "v4"
  }
});
